import React from 'react';
import PropTypes from 'prop-types';
import Category, {categoryPropTypes} from '../Category/Category';
import './CategoryCollection.less';

function CategoryCollection(props) {
    const {categories} = props;

    return (
        <div className="CategoryCollection">
            {categories.map((category, i) => {
                return <Category {...category} key={category.name || i}/>;
            })}
        </div>
    );
}

CategoryCollection.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape(...categoryPropTypes)).isRequired
};

CategoryCollection.defaultProps = {
    categories: []
};

export default CategoryCollection;
